import { Flex } from 'antd';
import { ProgressHeader } from 'pages/auth/registration/components/ProgressHeader';
import { useRef } from 'react';
import { useIntl } from 'react-intl';
import { GridContainer } from 'shared/ui';
import CodeInput, { CodeInputRef } from 'shared/ui/CodeInput/CodeInput';
import { useConfirmEmailCodeMutation, useSendEmailCodeQuery } from '../api';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setActivity } from 'shared/config/store/reducers/appSlice';
import { ApiError } from 'shared/model/types';
import { ROUTES } from 'shared/const/routes';
import { useLazyGetUserInfoQuery, useLazyGetUserQuery, useSaveGtagMutation } from 'entities/user';
import { GTAG_ID } from 'shared/const/app';
import { useMessage } from 'shared/libs/hooks';
import classes from './ConfirmEmail.module.css';

export const ConfirmEmail = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const email = params.get('email');
  const phone = params.get('phone');
  const codeRef = useRef<CodeInputRef>(null);
  const { formatMessage: t } = useIntl();
  const { showSuccess } = useMessage();
  const {refetch: refetchCodeSend } = useSendEmailCodeQuery();
  const [confirmEmailCode] = useConfirmEmailCodeMutation();
  const [fetchUserInfo] = useLazyGetUserInfoQuery();
  const [fetchUser] = useLazyGetUserQuery();
  const [saveGtag] = useSaveGtagMutation();

  const dispatch = useDispatch();

  const handleCodeConfirm = (code: string) => {
    dispatch(setActivity(true));
    confirmEmailCode({ code })
      .unwrap()
      .then(async () => {
        const [, userResult] = await Promise.all([
          fetchUserInfo(),
          fetchUser(),
        ]);
        
        gtag('get', GTAG_ID, 'client_id', (clientID) => {
          saveGtag({ clientId: clientID as string, eventName: 'web_email_verification_completed', gtag: GTAG_ID });
          gtag('event', 'web_email_verification_completed', {
            email_verification: true
          });
        });
        codeRef.current?.success();
        
        const isPhoneVerified = userResult.data?.response?.phoneVerified || false;
        
        if (!isPhoneVerified && phone) {
          navigate({ pathname: ROUTES.CONFIRM_PHONE.path, search: `phone=${phone}&email=${email}` });
        } else {
          showSuccess(t({ id: 'loginPage.welcome' }));
          navigate(ROUTES.DASHBOARD.path);
        }
      })
      .catch((error: ApiError) => {
        console.log(error);
        codeRef.current?.clear();
        codeRef.current?.error(t({ id: 'common.message.codeInvalid' }));
      })
      .finally(() => {
        dispatch(setActivity(false));
      })
  }

  return (
    <GridContainer>
      <div className={classes.container}>
        <Flex vertical gap={40} style={{ width: '100%' }}>
          <ProgressHeader sectionIndex={4} last={6} title={t({ id: 'screens.auth.email.title' })} onBack={() => navigate(ROUTES.LOGIN.path, { replace: true })} description={t({ id: 'screens.verifyEmail.subTitle' }, { email: email })} />
          <Flex justify='center' style={{ width: '100%' }}>
            <CodeInput timeout={30} ref={codeRef} isEmail onResend={refetchCodeSend} onEnter={handleCodeConfirm} />
          </Flex>
        </Flex>
      </div>
    </GridContainer>
  )
}